<template>
    <h1>{{ $t('page404.title') }}</h1>
</template>